import React from "react";
import { SiDeezer } from "react-icons/si";

const Deezer = ({ link, themeFontColor }) => {
  return (
    <div className="link-spotify link-el">
      <h2 style={{ color: themeFontColor }}>
        <SiDeezer className="icon-page-heading" />
        {link.LinkTitle}
      </h2>{" "}
      <div
        className="spotify-iframe"
        dangerouslySetInnerHTML={{ __html: link.LinkEmbedCode }}
      />
    </div>
  );
};

export default Deezer;
